import React, { useState } from 'react'
import { useIntl } from 'umi'
import { Dropdown, List, StatusTip } from 'tea-component'

import SelectPanel from './components/SelectPanel'
import CustomizedPanel from './components/CustomizedPanel'


const PANELS = {
  select: "select",
  customize: "customize"
}

export default function SelectWithCustomize(props) {
  const {
    value,
    placeholder,
    options,
    loading,
    customizeConfig,
    defaultValue,
    defaultEventType,
    onChange,
    onOpen,
    onClose,
    onSelectPanel,
    onCustomizedPanel
  } = props

  const { formatMessage } = useIntl();

  const [activePanel, setActivePanel] = useState(PANELS.select)
  const [text, setText] = useState(defaultEventType?.text || '');

  // 下拉面板变化事件
  const handlePanelChange = (activePanelId) => {
    if (activePanelId === PANELS.select) {
      onSelectPanel?.()
    } else {
      onCustomizedPanel?.()
    }
    setActivePanel(activePanelId)
  }


  // 固定列表选择变化事件
  const handleSelectChange = (selected) => {
    setText(selected.text)
    onChange?.({selectedValue: selected.value})
  }

  return (
    <>
      <Dropdown
        className="table-select"
        button={text ? text : (<span style={{color: "#BBBBBB"}}>{placeholder}</span>)}
        size="full"
        appearance='button'
        clickClose={false}
        onClose={onClose}
        onOpen={() => {
          setActivePanel(PANELS.select)
          onOpen?.();
        }}
      >
        {
          close => (
            <>
              <div style={{display: activePanel === PANELS.select ? "block" : "none"}}>
                <SelectPanel
                  loading={loading}
                  options={options}
                  onSelectChange={(selector) => {
                    handleSelectChange(selector);
                    close();
                  }}
                />

                <span className='dtb-db-tracking-day__action' onClick={() => handlePanelChange(PANELS.customize)}>{formatMessage({id: "common_customize"})}</span>

              </div>

              <div style={{display: activePanel === PANELS.customize ? "block" : "none"}}>
                <CustomizedPanel
                  onConfirm={(value) => {setText(value); onChange?.({customizedValue: value}); close()}}
                  onBack={() => {setActivePanel(PANELS.select)}}
                  {...customizeConfig}
                />
              </div>

            </>
          )
        }
      </Dropdown>
    </>
  )
}

